
const GeneralLayoutWrapper = ({ children }) => {
    return (children)
}
export default GeneralLayoutWrapper